import { Pause, PlayArrow } from "@mui/icons-material";
import { Box, IconButton, Slider } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { formatMinutes, formatSeconds } from "../../utils";

const formatAudioTime = (value) => {
  if (Number.isNaN(value) || value === Infinity) return "00:00";
  return `${formatMinutes(Math.floor(value / 60))}:${formatSeconds(
    Math.floor(value % 60)
  )}`;
};

const AudioPlayer = ({ url }) => {
  const audioRef = useRef(null);

  const [isPlaying, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const isDurationNan =
    !duration || Number.isNaN(duration) || duration === Infinity;

  const handleTimeUpdate = (ev) => {
    setCurrentTime(audioRef?.current?.currentTime ?? 0);
    setDuration(audioRef?.current?.duration);
  };

  const handleTooglePlay = () => {
    if (!isPlaying) audioRef?.current?.play();
    else audioRef?.current?.pause();
  };

  const handleSliderChange = (event, newValue) => {
    if (audioRef.current) audioRef.current.currentTime = newValue;
  };

  useEffect(() => {
    const setAudioMetadata = () => {
      setDuration(audioRef?.current?.duration || 0);
    };

    if (audioRef.current) {
      audioRef.current.addEventListener("loadedmetadata", setAudioMetadata);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener(
          "loadedmetadata",
          setAudioMetadata
        );
      }
    };
  }, []);

  return (
    <Box className="flex justify-between w-full items-center gap-3 border-[1px] border-[#00684E] rounded-md px-2 py-1 mb-4">
      <IconButton
        onClick={handleTooglePlay}
        size="small"
        className="text-[#00684E] "
        title="Play/Pause"
      >
        {isPlaying ? (
          <Pause className="text-2xl" />
        ) : (
          <PlayArrow className="text-2xl" />
        )}
      </IconButton>
      <Box className="w-32 mt-1.5">
        <Slider
          value={currentTime}
          min={0}
          max={isDurationNan ? currentTime + 1 : duration}
          size="small"
          onChange={handleSliderChange}
        />
      </Box>
      <div className=" flex items-center">
        <span className="text-xs">{formatAudioTime(currentTime)}</span>
        <span className="text-xs">/</span>
        <span className="text-xs">
          {formatAudioTime(isDurationNan ? currentTime : duration)}
        </span>
      </div>
      <audio
        ref={audioRef}
        onTimeUpdate={handleTimeUpdate}
        src={url}
        style={{ visibility: "hidden" }}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
      />
    </Box>
  );
};

export default AudioPlayer;
